// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Loading_spinnerContainer__3g6_d"};